import classNames from "classnames";

import {useCurrentUserContext} from "@/components/context/hooks.ts";
import {shortDateTime} from "@/lib/format.tsx";
import {IncidentUpdate} from "@/lib/types/statuspages.ts";
import {IncidentStateIcon} from "@/pages/incidents/components/incident-edit/components/updates/IncidentStateSelect/IncidentStateIcon.tsx";

import styles from "./IncidentTableUpdatesSubRow.module.scss";

export interface IncidentsTableUpdatesSubRowProps {
  update: IncidentUpdate;
}

export const IncidentsTableUpdatesSubRow = ({update}: IncidentsTableUpdatesSubRowProps) => {
  const {user} = useCurrentUserContext();
  const timezone = user!.account!.timezone;
  return (
    <div className={classNames("d-flex flex-row", styles.container)}>
      <div className={styles.verticalLine}>
        <div className={styles.iconSection}>
          <IncidentStateIcon state={update.incident_state} className={styles.incidentIcon} />
        </div>
        <div className={styles.bottomLine} />
      </div>
      <div className={classNames("d-flex flex-column", styles.content)}>
        <div className="d-flex flex-row gap-2">
          <span className="pulseTextBodySmallBold pulse-color-gray-800 text-capitalize">{update.incident_state}</span>
          {update.updated_at && (
            <span className="pulseTextBodySmall pulse-color-gray-700">
              {shortDateTime(update.updated_at, user!.current_date_format, user!.current_time_format, timezone)}
            </span>
          )}
        </div>
        {update.description_html && (
          <div
            className="pulseTextBodySmall pulse-color-gray-700 d-block"
            dangerouslySetInnerHTML={{__html: update.description_html || ""}}
          ></div>
        )}
      </div>
    </div>
  );
};
